import React from 'react';
import axios from 'axios';
import { CheckCircle2, Circle, X, PlayCircle } from "lucide-react";
import { Button } from "../ui/button";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const GettingStarted = ({ user, accounts, transactions, sentGifts, onDismiss, onReplayTour, onGoVerify, onGoCreate, onGoGift }) => {
  const steps = [
    { id: "identity", label: "Verifica tu identidad (CURP + INE)", done: ["documents_received", "verified"].includes(user?.verification_status), action: onGoVerify, cta: "Verificar" },
    { id: "account", label: "Crea la primera alcancía", done: accounts.length > 0, action: onGoCreate, cta: "Crear" },
    { id: "gift", label: "Invita a un padrino o envía un regalo", done: sentGifts.length > 0 || transactions.some((t) => t.type !== "gift_redemption"), action: onGoGift, cta: "Invitar" },
  ];
  const doneCount = steps.filter((s) => s.done).length;
  if (user?.checklist_dismissed || doneCount === steps.length) return null;
  const pct = Math.round((doneCount / steps.length) * 100);

  const dismiss = async () => {
    onDismiss();
    try { await axios.put(`${BACKEND_URL}/api/auth/me/onboarding`, { checklist_dismissed: true }); } catch { /* no-op */ }
  };

  return (
    <section data-testid="getting-started" className="rounded-3xl bg-white border border-gray-100 shadow-md p-6 relative">
      <button onClick={dismiss} data-testid="getting-started-dismiss" aria-label="Ocultar guía" className="absolute top-4 right-4 text-gray-300 hover:text-gray-500"><X className="w-4 h-4" /></button>
      <div className="flex flex-col md:flex-row md:items-center gap-4 mb-5">
        <div className="flex-1">
          <p className="text-xs uppercase tracking-[3px] font-bold text-brand-blue">Primeros pasos</p>
          <h3 className="text-xl font-extrabold text-brand-dark">Tu ruta para empezar a ahorrar</h3>
        </div>
        <div className="flex items-center gap-3">
          <div className="w-32 h-2 rounded-full bg-gray-100 overflow-hidden"><div className="h-full bg-brand-green transition-[width] duration-700" style={{ width: `${pct}%` }} /></div>
          <span className="text-sm font-bold text-brand-dark" data-testid="getting-started-progress">{doneCount}/{steps.length}</span>
        </div>
      </div>
      <ul className="grid md:grid-cols-3 gap-3">
        {steps.map((s, i) => (
          <li key={s.id} data-testid={`getting-started-step-${s.id}`} className={`rounded-2xl border p-4 flex flex-col gap-3 ${s.done ? "border-brand-green/40 bg-brand-lightGreen/40" : "border-gray-100"}`}>
            <div className="flex items-start gap-2">
              {s.done ? <CheckCircle2 className="w-5 h-5 text-brand-green shrink-0" /> : <Circle className="w-5 h-5 text-gray-300 shrink-0" />}
              <p className={`text-sm font-bold ${s.done ? "text-gray-500 line-through" : "text-brand-dark"}`}>{s.label}</p>
            </div>
            {!s.done && i === doneCount && (
              <Button size="sm" onClick={s.action} data-testid={`getting-started-cta-${s.id}`} className="self-start rounded-full bg-brand-blue text-white font-bold h-8">{s.cta}</Button>
            )}
          </li>
        ))}
      </ul>
      <button onClick={onReplayTour} data-testid="getting-started-replay" className="mt-4 text-xs text-gray-500 hover:text-brand-blue inline-flex items-center gap-1"><PlayCircle className="w-3.5 h-3.5" /> Ver la guía de bienvenida otra vez</button>
    </section>
  );
};
